import { Controller } from 'stimulus'
import $ from 'jquery'

/*
 * This simple controller is useful when you want to defer the initialization of JS
 * that would've been otherwise been invoked
 * if the element were connected to the DOM
 * You can do so by wrapping your content in a <template> tag
 * And then using this controller to call `untemplate` on appopriate events
 */
export default class extends Controller {
  static targets = ['template']

  untemplate = () => {
    this.templateTargets.forEach((template) => {
      const $newEl = $(template.innerHTML)
      $(template).replaceWith($newEl)
      $newEl.changed?.()
      this.untemplated = true
    })
  }

  templateTargetConnected = () => {
    if (!this.untemplated) return

    this.untemplate()
  }
}
